import { useVaults, Vault } from '@app/hooks/plugins/useVaults';
import { useIchiVaultsList } from '@app/hooks/ichi/useIchiVaultsList';
import { useMemo } from 'react';
import { useGammaVaults } from '@app/hooks/gamma/useGammaVaults';

export function useAllProvidersVaults() {
  const { data: steerVaults, isLoading: isLoadingSteerVaults } = useVaults();
  const { data: ichiVaults, isLoading: isLoadingIchiVaults } =
    useIchiVaultsList();
  const { data: gammaVaults, isLoading: isLoadingGammaVaults } =
    useGammaVaults();

  const isLoading = isLoadingSteerVaults && isLoadingIchiVaults;

  const data = useMemo(() => {
    const _steerVaults =
      steerVaults?.map(item => {
        return {
          ...item,
          provider: 'Steer'
        };
      }) ?? [];
    const _ichiVaults =
      ichiVaults?.map(item => {
        return {
          ...item,
          provider: 'Ichi'
        };
      }) ?? [];
    const _gammaVaults =
      gammaVaults?.map(item => {
        return {
          ...item,
          provider: 'Gamma'
        };
      }) ?? [];

    return [..._ichiVaults, ..._steerVaults, ..._gammaVaults] as Vault[];
  }, [ichiVaults, steerVaults, gammaVaults]);

  return { data, isLoading };
}
